import { partner } from '../../api/partner';
import { ErrorBlock } from '../../components/ErrorBlock';
import { Loading } from '../../components/Loading';
import { PageHeader } from '../../components/PageHeader';
import { useT } from '../../i18n';
import { useFormat } from '../../lib/format';
import { useAsync } from '../../lib/useAsync';
import { blockingDocs, docNames } from '../../lib/vehicleDocs';

export function VehiclesPage() {
  const t = useT();
  const f = useFormat();
  const q = useAsync(() => partner.vehicles(), []);
  return (
    <>
      <PageHeader title={t('veh.title')} back="/trips" />
      {q.loading && !q.data ? <Loading /> : null}
      {q.error ? <ErrorBlock error={q.error} onRetry={() => void q.reload()} /> : null}
      {q.data && !q.data.length ? <p className="text-lab">{t('veh.empty')}</p> : null}
      <ul className="space-y-3">
        {(q.data ?? []).map((v) => (
          <li key={v.id} className="card text-[15px]">
            <p className="text-[18px] font-semibold">{v.plate}</p>
            {v.model ? <p className="text-txt">{v.model}</p> : null}
            {v.default_driver_name ? <p className="text-lab">{t('veh.driver', { name: v.default_driver_name })}</p> : null}
            {blockingDocs(v).length ? (
              <p className="mt-1 text-bad" data-testid="veh-docs">
                {t('veh.docsMissing', { docs: docNames(blockingDocs(v), f.locale) })}
              </p>
            ) : null}
            {v.next_trip ? (
              <>
                <p className="mt-1">{t('veh.next', { route: v.next_trip.route })}</p>
                <p className="text-lab">{t('veh.free', { n: v.next_trip.free_min, total: v.next_trip.capacity })}</p>
              </>
            ) : (
              <p className="mt-1 text-lab">{t('veh.noTrip')}</p>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}
